import React, { useEffect, useMemo, useRef, useState } from 'react';

import SupportAccordion from './SupportAccordion';
import SupportButtonTypeLinks from './SupportButtonTypeLinks';
import SupportLinksWithThumbnails from './SupportLinksWithThumbnails';
import SupportDropdownTextEditor from './SupportDropdownTextEditor';
import SupportSlider from './SupportSlider';
import SupportTwoColumnsLayout from './SupportTwoColumnsLayout';
import translations from '../../../text/get-started-translations.json';
import language from '../../../utils/LanguageSettings';

interface SupportDropdownProps {
    element: any
}
interface DrowndownItem {
    id: number;
    label: string;
    content: any;
}


const SupportDropdown: React.FC<SupportDropdownProps> = (element) => {
    const pageTranslations = translations[language];
    const [items, setItems] = useState<DrowndownItem[]>([]);
    const [DropdownContent, setDropdownContent] = useState<any[]>([]);
    const Content: React.SetStateAction<any[]> = [];
    const listenerRef = useRef(null);
    const [selectedId, setSelectedId] = useState<number | 0>(0);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
      const newItems: DrowndownItem[] = [{id:0 , label: pageTranslations.supportSelect, content: ""}];
      element?.element?.DropdownItems.data.forEach((element: any, index: number) => {
        newItems.push({ id: index+1, label: element?.attributes?.DropdownOption, content: element?.attributes?.DropdownContent });
      });
      setItems(newItems);
    }, [element]);


    const handleDropdownContent = (item: any, id: number) => {
        setDropdownContent([]);
        if(id == 0){
            return;
        }
        item[id]?.content?.forEach((element:  {__component: string}, index: number) => {
            switch(element?.__component){
                case "support.dropdown-text-editor":
                    Content.push(<SupportDropdownTextEditor element={element} key={index}/>);
                    break;
                case "support.button-type-links":
                    Content.push(<SupportButtonTypeLinks element={element}  key={index}/>);
                    break;
                case "support.links-with-thumbnails":
                    Content.push(<SupportLinksWithThumbnails element={element}  key={index}/>);
                    break;
                case "support.accordion":
                    Content.push(<SupportAccordion element={element}  key={index}/>);
                    break;
                case "support.slider":
                    Content.push(<SupportSlider element={element} key={index}/>);
                    break;
                case "support.two-columns-layout":
                    Content.push(<SupportTwoColumnsLayout element={element} key={index}/>);
                    break;
            }
        });
        setDropdownContent(Content);
    }

      useEffect(() => {
        const handleLiener = (event: any) => {
          const targetDiv = document.getElementsByClassName('select-container')[0];
          if (targetDiv && !targetDiv.contains(event.target)) {
            setIsOpen(false);
          }
        };
    
        listenerRef.current = handleLiener;
    
        if (isOpen) {
          document.addEventListener('click', handleLiener);
        } else {
          document.removeEventListener('click', handleLiener);
        }
    
        return () => {
          document.removeEventListener('click', listenerRef.current);
        };
      }, [isOpen]);


  const handleOptionClick = (id: number) => {
    setSelectedId(id);
    setIsOpen(false);
    handleDropdownContent(items, id);
  };


    
    return (
      <>
        <div className="support support-select container-fluid spacer-top dropdown-layout">
            <h2 className="text-center mb-3 font-medium">{element?.element?.MainTitle}</h2>
            <div className="select-container">
                <div className={`select-display ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                    {selectedId ? items.find(option => option.id === selectedId)?.label : pageTranslations.supportSelect}
                </div>
                {isOpen && (
                    <ul className="select-options" style={{zIndex:999}}>
                    {items.map(option => (
                        <li
                        key={option.id}
                        className={`select-option ${selectedId == option.id ? 'selected' : ''}`}
                        onClick={() => handleOptionClick(option.id)}
                        >
                        {option.label}
                        </li>
                    ))}
                    </ul>
                )}
            </div>
            {DropdownContent ? DropdownContent : <></>}
        </div>
      </>
    );
};

export default SupportDropdown;